import {createContext, useState} from "react";
import axios from "axios"
// import { useNavigate} from 'react-router-dom'
import toast from "react-hot-toast"


export const Context1 = createContext();

const AppContext = ({children}) => {
    // const [auth, setAuth] = useState({
    //     user:null,
    //     token:"",
    // });

    
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [user, setUser] = useState(null);
    const [gAuth, setGAuth] = useState(null);
    // const navigate = useNavigate();

    const handleRegisterSubmit = async (e) =>{
        e.preventDefault();
        try {
            const res = await axios.post(`${process.env.REACT_APP_API}/api/v1/auth/register`, {name, email, password,});
            if(res && res.data.success){
                toast.success(res.data && res.data.message);
                // setAuth({
                //     ...auth,
                //     user: res.data.user,
                //     token: res.data.token,
                // })
                // localStorage.setItem("auth",JSON.stringify(res.data));
                setUser(true);
            } else {
                toast.error(res.data.message);
            }

        } catch (error) {
            console.log(error);
            toast.error("Something went wrong");
        }
    }



    //Login form submit
    const handleLoginSubmit = async (e) =>{
        e.preventDefault();
        try {
            const res = await axios.post(`${process.env.REACT_APP_API}/api/v1/auth/login`, {email, password,});
            if(res && res.data.success){
                toast.success(res.data && res.data.message);
                setUser(true)
            } else {
                toast.error(res.data.message);
            }

        } catch (error) {
            console.log(error);
            toast.error("Something went wrong");
        }
    }

    const logout = () => {
		window.open(`${process.env.REACT_APP_API}/auth/logout`, "_self");
        setGAuth(false)
	};

    // useEffect(() => {
    //     const data = localStorage.getItem("auth");
    //     if(data){
    //         const parseData = JSON.parse(data)
    //         setAuth({
    //             ...auth,
    //             user: parseData.user,
    //             token: parseData.token,
    //         })
    //     }
    // },[auth]);
    return (
        <Context1.Provider value={{user, setUser, gAuth, setGAuth, name, setName, email, setEmail, password, setPassword, handleRegisterSubmit, handleLoginSubmit, logout}}>
            {children}
        </Context1.Provider>
    )
}

// custom hook

// const useAuth =() => useContext(Context)

export default AppContext;